package com.starparty.app.astro0.celestialbodies

import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.SP_Time
import kotlin.math.pow
import kotlin.math.sqrt

abstract class OrbitalBody : CelestialBody() {

    protected var m_d = 0.0 // day number
    protected var mEcl = 0.0 // obliquity of the ecliptic
    var m_r =0.0 // distance = 0.0
        protected set
    protected var m_v = 0.0 // true anomaly
    var mOEs: DoubleArray
    protected var mElementsData: OrbitalElementsData? = null

    fun setOrbitalElementsData(elements: OrbitalElementsData?) {
        mElementsData = elements
    }

    open fun recalculateOrbitalElements(t: SP_Time) {

        if (null == mElementsData){
            return
        }

        val epoch = t.epoch.toDouble()

        m_d = t.dayNumber

        val eConstants = mElementsData!!.mConstants
        val eCoeffs = mElementsData!!.mCoeffs
        for (i in eCoeffs!!.indices) {
            mOEs[i] = eConstants!![i] + eCoeffs[i] * m_d
        }
        mOEs[M] =
            MathD.equivalentAngleBetweenZeroAnd360(mOEs[M])
        mOEs[w1] =
            mOEs[N] + mOEs[w]
        mOEs[L] =
            mOEs[M] + mOEs[w1]
        mOEs[L] =
            MathD.equivalentAngleBetweenZeroAnd360(mOEs[L])
        mOEs[q] =
            mOEs[a] * (1 - mOEs[e])
        mOEs[Q] =
            mOEs[a] * (1 + mOEs[e])
        mOEs[P] =
            mOEs[a].pow(1.5)
        mOEs[T] =
            epoch - mOEs[M] / MathD.DEG_360 / mOEs[P]
        mEcl = 23.4393 - 3.563E-7 * m_d
    }

    protected fun calculateDistanceAndTrueAnomaly(E: Double) {

        if (null == mElementsData){
            return
        }

        val xv =
            mOEs[a] * (MathD.cosD(E) - mOEs[e])
        val yv = mOEs[a] * (sqrt(
            1.0 - mOEs[e] * mOEs[e]
        ) * MathD.sinD(E))
        m_v = MathD.atanD2(yv, xv) // true anomaly
        m_r = sqrt(xv * xv + yv * yv) // distance
    }

    protected fun calculateFirstAproxOfE(): Double {

        if (null == mElementsData){
            return 0.0
        }

        return mOEs[M] + (mOEs[e] / MathD.DEG_TO_RAD * MathD.sinD(
            mOEs[M]
        )
                * (1.0 + mOEs[e] * MathD.cosD(mOEs[M])))
    }

    companion object {
        // Enumerators for primary orbital elements
        const val N = 0

        // longitude of perihelion
        const val i = 1

        // inclination to the ecliptic (plane of the Earth's orbit)
        const val w = 2

        // argument of perihelion
        const val a = 3

        // semi-major axis, or mean distance from Sun
        const val e = 4

        // eccentricity (0=circle, 0-1=ellipse, 1=parabola)
        const val M = 5 // mean anomaly (0 at perihelion; increases uniformly with time)

        // Enumerators for related orbital elements derived from primary OEs
        const val w1 = 6

        // longitude of perihelion
        const val L = 7

        // mean longitude
        const val q = 8

        // perihelion distance
        const val Q = 9

        // aphelion distance
        const val P = 10

        // orbital period (years if a is in AU, astronomical units)
        const val T = 11 // Epoch_of_M - (M(deg)/360_deg) / P  = time of perihelion
    }

    init {
        mOEs = DoubleArray(T + 1)
    }
}